<template>
	<div class="page plr16">
		<div class="ptb16">
			<p style="font-weight: bold;">会员分析<span class="moneys fontSize14">(数据指标可能存在一定的延迟)</span></p>
		</div>
		<div class="mains-content">
			<div class="member-content-box">
				<div class="flex-row pb16">
					<p class="titles mr10"><v-date @time="change" :clearable="false"></v-date></p>
          <el-button type="primary" @click="doData">搜索</el-button>
				</div>
				<el-tabs class="tabs" v-model="queryType" type="card" @tab-click="tableChange">
					<el-tab-pane label="充值排名" name="recharge"></el-tab-pane>
					<el-tab-pane label="消费排名" name="ranking"></el-tab-pane>
					<el-tab-pane label="消费频次" name="frequency"></el-tab-pane>
				</el-tabs>
				<el-table :data="list" :max-height="height - 290">
					<el-table-column prop="index" label="排名" width="50">
            <template slot-scope="scope">
              {{ scope.$index + 1}}
            </template>
          </el-table-column>
					<el-table-column prop="memberNameAndMobile" label="会员" align="center"></el-table-column>
					<el-table-column prop="rechargeAmount" label="充值金额/次数" align="center" v-if="queryType == 'recharge'">
            <template slot-scope="scope">
              ￥{{ scope.row.rechargeAmount }}/{{ scope.row.rechargeTotal }}次
            </template>
          </el-table-column>
					<el-table-column prop="consumeAmount" label="消费金额/次数" align="center" v-if="queryType == 'ranking'">
            <template slot-scope="scope">
              ￥{{ scope.row.consumeAmount }}/{{ scope.row.consumeTotal }}次
            </template>
          </el-table-column>
					<el-table-column prop="consumeTotal" label="消费频次" align="center" v-if="queryType == 'frequency'">
            <template slot-scope="scope">
              {{ scope.row.consumeTotal }}次
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="120px">
            <template slot-scope="scope">
              <el-link type="primary" @click="skip(scope.row)">详情</el-link>
            </template>
          </el-table-column>
				</el-table>
        <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
			</div>
		</div>
	</div>
</template>

<script>
import minxin from '../../../assets/javascript/minxin.js'
export default {
	mixins: [minxin],
	data() {
		return {
			list: [],
      url: this.$url.memberDataDay.listOfRecharge,
      urlCount: this.$url.memberDataDay.countOfRecharge,
      queryType: 'recharge',
			query: {
				size: 20,
				start: 1,
			},
      height: this.$store.getters.MainHeight,
      totalCount: 0
		}
	},
	mounted() {
		this.totalCounts()
	},
	methods: {
		change(value) {
			this.query.beginTime = value[0] ? this.formatDay(value[0]) : ''
			this.query.endTime = value[1] ? this.formatDay(value[1]) : ''
    },
    totalCounts () {
      if (this.query.beginTime == undefined || this.query.beginTime == '') {
				this.query.beginTime = this.getCurrentDate()
			}
			if (this.query.endTime == undefined || this.query.endTime == '') {
				this.query.endTime = this.getCurrentDate()
			}
      this.$api.post(this.urlCount, this.query).then(res => {
        this.getData();
        this.totalCount = res || 0;
      }).catch(error => {});
    },
		tableChange(val) {
			this.list = []
			this.query.start = 1
			this.queryType = val.name

			if (val.name == 'recharge') {
				this.url = this.$url.memberDataDay.listOfRecharge
				this.urlCount = this.$url.memberDataDay.countOfRecharge
			} else if (val.name == 'ranking') {
				this.url = this.$url.memberDataDay.listOfConsume
				this.urlCount = this.$url.memberDataDay.countOfConsume
      } else if (val.name == 'frequency') {
				this.url = this.$url.memberDataDay.listOfConsumeTotal
				this.urlCount = this.$url.memberDataDay.countOfConsumeTotal
      }
      this.totalCounts()
    },
    skip (item) {
      let obj = JSON.stringify({beginTime: this.query.beginTime, endTime: this.query.endTime, tradeTypes: this.queryType == 'recharge' ? ['recharge', 'withdraw']:['consume', 'refund']})
      this.$router.push(`/member/detail/${item.memberId}?item=${obj}`)
    }
	},
}
</script>
